export const formatDateInput = (value: string) => {
    const [typedMonth = '', typedDay = '', typedYear = ''] = value
        .replace(/[^\d/]/g, '')
        .split('/');
    const dayDigits = typedMonth.slice(2) + typedDay;
    const segments = [
        typedMonth.slice(0, 2),
        dayDigits.slice(0, 2),
        (dayDigits.slice(2) + typedYear).slice(0, 4),
    ];
    const slashCount = Math.max(
        value.split('/').length - 1,
        typedMonth.length > 2 ? 1 : 0,
        dayDigits.length > 2 ? 2 : 0
    );
    return segments.slice(0, slashCount + 1).join('/');
};
